import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    currentSlideshow: null,
    villaPageGallery: null,
  },
  getters: {
    getCurrentSlideshow: (state) => {
      if (state.currentSlideshow) {
        return state.currentSlideshow;
      }
    },
    getVillaPageGallery: (state) => {
      if (state.villaPageGallery) {
        return state.villaPageGallery;
      }
    },
    getImageURLforSize: (state) => (src, newSize) => {
      src = src.replace(/\/68\/|\/80\/|\/200\/|\/400\/|\/520\/|\/1000\/|\/1920\//gi, `/${newSize}/`);
      return `https://www.thethinkingtraveller.com/media${src}`;
    },
  },
  mutations: {
    setCurrentSlideshow: (state, data) => {
      state.currentSlideshow = data;
    },
    setVillaPageGallery: (state, data) => {
      state.villaPageGallery = data;
    },
  },
  actions: {
    fetchSlideshowImagesById({
      commit, dispatch, getters, rootGetters,
    }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/slideshows/${id}/images/lang/${rootGetters['pages/currentLang']}`)
          .then((res) => {
            commit('setCurrentSlideshow', res.data);
            resolve(res);
          })
          .catch((error) => {
            console.log(`Error fetching slideshow ${id}`);
          });
      });
    },
  },
};
